// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__-VbYH","position":"style_position__2f7q+"};